import type React from 'react';
import { FormField, fieldDescribedBy } from '~/components/form/FormField';

export interface CheckboxProps {
  id: string;
  /** What checking it means, beside the box. */
  text: React.ReactNode;
  checked: boolean;
  onChange: (checked: boolean) => void;
  /** Optional label line above, when the checkbox sits in a row of labelled fields. */
  label?: string;
  helperText?: React.ReactNode;
  disabled?: boolean;
  testId?: string;
  ariaLabel?: string;
  /** An outside element that also describes this field (its id). */
  describedBy?: string;
}

/** A checkbox as a form field: the `FormField` frame, the box and its text in a `field-control-row`. */
export function Checkbox({
  id,
  text,
  checked,
  onChange,
  label,
  helperText,
  disabled,
  testId,
  ariaLabel,
  describedBy,
}: CheckboxProps) {
  return (
    <FormField id={id} label={label} helperText={helperText}>
      <label
        htmlFor={id}
        className={`field-control-row ${disabled ? 'cursor-not-allowed text-gray-400' : 'cursor-pointer'}`}
      >
        <input
          id={id}
          type="checkbox"
          checked={checked}
          disabled={disabled}
          aria-label={ariaLabel}
          aria-describedby={fieldDescribedBy(id, helperText, undefined, describedBy)}
          onChange={(event) => onChange(event.target.checked)}
          className="focus-ring size-4 shrink-0 rounded border-gray-300 accent-brand-500 disabled:cursor-not-allowed dark:border-gray-700"
          data-testid={testId}
        />
        <span>{text}</span>
      </label>
    </FormField>
  );
}
